/** What a page shows when it throws: the app's own words, the error for the report, a reload. react-router's errorElement. */
import { T } from '@/i18n';
import { Button, Panel } from '@/ui';
import { Link, useRouteError } from 'react-router-dom';

export default function Crash() {
  const err = useRouteError() as { message?: string; statusText?: string; status?: number } | undefined;
  const text = err?.message || err?.statusText || String(err ?? '');
  return (
    <div style={{ maxWidth: 560, margin: '40px auto', padding: '0 16px' }} data-testid="app-error">
      <div className="ph">
        <h1>{T('Noe gikk galt på denne siden')}</h1>
      </div>
      <Panel>
        <p style={{ margin: '0 0 10px' }}>
          {T(
            'Siden stoppet på en feil. Resten av appen virker; last inn igjen eller gå til forsiden. Ta med teksten under om du melder det.',
          )}
        </p>
        <pre
          className="mono"
          style={{
            whiteSpace: 'pre-wrap',
            background: 'var(--sunken)',
            padding: 10,
            borderRadius: 6,
            fontSize: 12,
          }}
        >
          {text}
        </pre>
        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <Button tone="pri" onClick={() => location.reload()}>
            {T('Last inn igjen')}
          </Button>
          <Link className="btn" to="/">
            {T('Til start')}
          </Link>
        </div>
      </Panel>
    </div>
  );
}
